export default __webpack_public_path__ + "static/media/6.db644fc2.svg";